if (!customElements.get('sk-clamp-height')) {
  const RESIZE_DEBOUNCE_MS = 100;

  class SiMaxHeight extends HTMLElement {
    connectedCallback() {

      this.content = this.querySelector('.max-height__inner-content');
      this.toggle = this.querySelector('.max-height__toggle');
      if (!this.content || !this.toggle) return;

      this.max = parseInt(this.dataset.max, 10) || 0;

      this.onToggle = () => this.classList.toggle('max-height__enabled');
      this.onResize = debounce(() => this.measure(), RESIZE_DEBOUNCE_MS);

      this.toggle.addEventListener('click', this.onToggle);
      window.addEventListener('resize', this.onResize, { passive: true });

      this.measure();
    }

    disconnectedCallback() {

      window.removeEventListener('resize', this.onResize);
      this.toggle?.removeEventListener('click', this.onToggle);
    }

    measure() {
      const overflows = this.max > 0 && this.content.offsetHeight > this.max;
      this.toggle.hidden = !overflows;
      this.classList.toggle('clamp--active', overflows);
    }
  }

  customElements.define('sk-clamp-height', SiMaxHeight);
}
